export const APP_DETAILS = {
  name: 'RFID Web',
  appLogoImage: require('assets/images/logo/logo.png').default,
  appLogoFullImage: require('assets/images/logo/logo_full.png').default
};

export const sessionConfig = {
  userData: `${APP_DETAILS.name} userData`,
  lang: `${APP_DETAILS.name} lang`,
  direction: `${APP_DETAILS.name} direction`,
  mode: `${APP_DETAILS.name} mode`,
  menuCollapsed: `${APP_DETAILS.name} menuCollapsed`,
  IpGuid: `${APP_DETAILS.name} IpGuid`,
  WcGuid: `${APP_DETAILS.name} WcGuid`,
  project: `${APP_DETAILS.name} project`,
  product: `${APP_DETAILS.name} product`,
  products: `${APP_DETAILS.name} products`,
  version: `${APP_DETAILS.name}version`,
  storageTokenKeyName: `${APP_DETAILS.name} accessToken`,
  storageRefreshTokenKeyName: `${APP_DETAILS.name} refreshToken`,
  mantisConfig: `${APP_DETAILS.name} mantis-react-ts-config`
};

export const userRoleList = ['CanDoAnything', 'user.create'];

export const ipRoleList = ['CanDoAnything', 'ip.create'];

export const wcRoleList = ['CanDoAnything', 'wc.create'];

export const OTPLoginType = {
  EMAIL: 'Email',
  MOBILE: 'Phone'
};

export const SETTING_ROW_STATUS = {
  NOCHANGE: 0,
  INSERTED: 1,
  UPDATED: 2,
  DISABLED: 3,
  ENABLED: 4,
  ERROR: -1
};

export const LOG_STATUS = {
  NEW: 'NewRecord',
  UPDATE: 'UpdateDetail',
  ENABLE: 'Enable',
  DISABLE: 'Disable'
};
